import React from 'react';
import { Box, Button } from '@material-ui/core';

const buttonStyles = { borderRadius: 20, width: 190, height: 40, color: "#fff" };

const ReportFooter = ({
                   onSave,
                   onSaveStyles,
                   buttonLabel = 'GERAR',
                   disabled = false,
                   removeSpacing,
                 }) => {
  return (
    <Box mt={removeSpacing ? 2 : 8} mb={2} width="100%">
      <Box p={4} bgcolor="rgba(0, 0, 0, 0.05)" width="100%" display="flex" justifyContent="center">
            <Button
              disabled={disabled}
              onClick={onSave}
              disableElevation
              color='secondary'
              variant="contained"
              style={{ ...buttonStyles, ...onSaveStyles }}
            >
              {buttonLabel}
            </Button>
      </Box>
    </Box>
  );
};

export default ReportFooter;
